import { render, staticRenderFns } from "./BidAgent.vue?vue&type=template&id=160ce32c&lang=pug"
import script from "./BidAgent.vue?vue&type=script&lang=js"
export * from "./BidAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports